import { render } from "./TradeFrom.vue?vue&type=template&id=cdbf377e&scoped=true"
import script from "./TradeFrom.vue?vue&type=script&lang=js"
export * from "./TradeFrom.vue?vue&type=script&lang=js"

import "./TradeFrom.vue?vue&type=style&index=0&id=cdbf377e&lang=scss"
import "./TradeFrom.vue?vue&type=style&index=1&id=cdbf377e&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdbf377e"]])

export default __exports__